jQuery_T4NT(document).ready(function($) {
  document.querySelectorAll('#CustomSizeTab input').forEach((ele) => {
    ele.addEventListener("input", function () {
      if (this.value < 0) {
        this.value = 0;
      }
    });
  });
  $(document).on("variant:changed", function (evt) {
    // console.log(evt.currentVariant.title);
    if (evt.currentVariant.title.includes('Customised')) {
      document.querySelectorAll('#CustomSizeTab input').forEach((ele) => {
        ele.removeAttribute("disabled");
      });
    } else {
      document.querySelectorAll('#CustomSizeTab input').forEach((ele) => {
        ele.setAttribute("disabled", "disabled");
      });
    };
  });
});


(function () {
  "use strict";
  function initialiseStickyChildDrawers(scope) {
    const root = scope || document;
    root
      .querySelectorAll("[data-zs-sticky-child]")
      .forEach(function (stickyDrawer) {
        if (stickyDrawer.dataset.zsInitialised === "true") {
          return;
        }
        const sectionContainer = stickyDrawer.closest(
          ".sr4-product__info-container"
        );
        const childProductArea = sectionContainer
          ? sectionContainer.querySelector(
              "[data-zs-child-product-area]"
            )
          : document.querySelector(
              "[data-zs-child-product-area]"
            );
        const openButton = stickyDrawer.querySelector(
          "[data-zs-sticky-open]"
        );
        const closeButtons = stickyDrawer.querySelectorAll(
          "[data-zs-sticky-close]"
        );
        const drawer = stickyDrawer.querySelector(
          ".zs-sticky-child__drawer"
        );
        const drawerContent = stickyDrawer.querySelector(
          "[data-zs-sticky-destination]"
        );
        if (
          !childProductArea ||
          !openButton ||
          !drawer ||
          !drawerContent
        ) {
          console.warn(
            "Sticky child-product drawer could not be initialised."
          );

          return;
        }
        stickyDrawer.dataset.zsInitialised = "true";
        /*
         * Save the child-product area's original position.
         */
        const originalParent = childProductArea.parentNode;

        const placeholder = document.createComment(
          "zs-child-product-original-position"
        );
        originalParent.insertBefore(
          placeholder,
          childProductArea
        );
        function openDrawer() {
          /*
           * Move the existing child-product content into the drawer.
           */
          drawerContent.appendChild(childProductArea);

          stickyDrawer.classList.add("is-open");

          openButton.setAttribute(
            "aria-expanded",
            "true"
          );

          drawer.setAttribute(
            "aria-hidden",
            "false"
          );

          document.body.classList.add(
            "zs-sticky-child-open"
          );

          window.setTimeout(function () {
            const firstInteractiveElement =
              drawerContent.querySelector(
                "select:not([disabled]), " +
                "input:not([disabled]), " +
                "button:not([disabled]), " +
                "[tabindex]:not([tabindex='-1'])"
              );

            if (firstInteractiveElement) {
              try {
                firstInteractiveElement.focus({
                  preventScroll: true
                });
              } catch (error) {
                firstInteractiveElement.focus();
              }
            }
          }, 300);
        }

        function closeDrawer(restoreFocus) {
          stickyDrawer.classList.remove("is-open");

          openButton.setAttribute(
            "aria-expanded",
            "false"
          );

          drawer.setAttribute(
            "aria-hidden",
            "true"
          );

          document.body.classList.remove(
            "zs-sticky-child-open"
          );

          /*
           * Move the child-product content back to its
           * original position on the product page.
           */
          if (placeholder.parentNode) {
            placeholder.parentNode.insertBefore(
              childProductArea,
              placeholder.nextSibling
            );
          }

          /*
           * Only return focus when the drawer was closed manually.
           * Do not return focus when the cart drawer is about to open.
           */
          if (
            restoreFocus !== false &&
            document.body.contains(openButton)
          ) {
            window.setTimeout(function () {
              try {
                openButton.focus({
                  preventScroll: true
                });
              } catch (error) {
                openButton.focus();
              }
            }, 50);
          }
        }

        openButton.addEventListener(
          "click",
          function () {
            openDrawer();
          }
        );

        closeButtons.forEach(function (closeButton) {
          closeButton.addEventListener(
            "click",
            function () {
              closeDrawer(true);
            }
          );
        });

        document.addEventListener(
          "keydown",
          function (event) {
            if (
              event.key === "Escape" &&
              stickyDrawer.classList.contains("is-open")
            ) {
              closeDrawer(true);
            }
          }
        );

        /*
         * The child-product Add to Cart code dispatches this event
         * after Shopify successfully adds the selected products.
         */
        document.addEventListener(
          "zs:close-sticky-drawer",
          function () {
            if (
              stickyDrawer.classList.contains("is-open")
            ) {
              closeDrawer(false);
            }
          }
        );

        /*
         * Fallback for themes that dispatch cart:updated.
         */
        document.addEventListener(
          "cart:updated",
          function () {
            if (
              stickyDrawer.classList.contains("is-open")
            ) {
              closeDrawer(false);
            }
          }
        );
      });
  }

  document.addEventListener(
    "DOMContentLoaded",
    function () {
      initialiseStickyChildDrawers(document);
    }
  );
  /*
   * Reinitialise when Shopify reloads the product section
   * in the Theme Editor.
   */
  document.addEventListener(
    "shopify:section:load",
    function (event) {
      initialiseStickyChildDrawers(event.target);
    }
  );
})();


// ---NEW
(function () {
  "use strict";

  function initialiseStickyProductFormDrawers(scope) {
    const root = scope || document;

    root
      .querySelectorAll("[data-zs-sticky-product-form]")
      .forEach(function (stickyDrawer) {

        if (stickyDrawer.dataset.zsInitialised === "true") {
          return;
        }

        const sectionContainer = stickyDrawer.closest(
          ".sr4-product__info-container"
        );

        const productFormArea = sectionContainer
          ? sectionContainer.querySelector(
              "[data-zs-product-form-area]"
            )
          : document.querySelector(
              "[data-zs-product-form-area]"
            );

        const openButton = stickyDrawer.querySelector(
          "[data-zs-product-form-open]"
        );

        const closeButtons = stickyDrawer.querySelectorAll(
          "[data-zs-product-form-close]"
        );

        const drawer = stickyDrawer.querySelector(
          ".zs-sticky-product-form__drawer"
        );

        const drawerContent = stickyDrawer.querySelector(
          "[data-zs-product-form-destination]"
        );

        if (
          !productFormArea ||
          !openButton ||
          !drawer ||
          !drawerContent
        ) {
          console.warn(
            "Sticky product-form drawer could not be initialised."
          );

          return;
        }

        stickyDrawer.dataset.zsInitialised = "true";

        /*
         * Save original product-form position
         */
        const originalParent = productFormArea.parentNode;

        const placeholder = document.createComment(
          "zs-product-form-original-position"
        );

        originalParent.insertBefore(
          placeholder,
          productFormArea
        );

        function openDrawer() {

          /*
           * Move the EXISTING product form into drawer.
           * We are not cloning it.
           */
          drawerContent.appendChild(productFormArea);

          stickyDrawer.classList.add("is-open");

          openButton.setAttribute(
            "aria-expanded",
            "true"
          );

          drawer.setAttribute(
            "aria-hidden",
            "false"
          );

          document.body.classList.add(
            "zs-sticky-product-form-open"
          );
        }

        function closeDrawer(restoreFocus) {

          stickyDrawer.classList.remove("is-open");

          openButton.setAttribute(
            "aria-expanded",
            "false"
          );

          drawer.setAttribute(
            "aria-hidden",
            "true"
          );

          document.body.classList.remove(
            "zs-sticky-product-form-open"
          );

          /*
           * Put product form back in original position
           */
          if (placeholder.parentNode) {
            placeholder.parentNode.insertBefore(
              productFormArea,
              placeholder.nextSibling
            );
          }

          if (
            restoreFocus !== false &&
            document.body.contains(openButton)
          ) {
            window.setTimeout(function () {
              try {
                openButton.focus({
                  preventScroll: true
                });
              } catch (error) {
                openButton.focus();
              }
            }, 50);
          }
        }

        openButton.addEventListener(
          "click",
          function () {
            openDrawer();
          }
        );

        closeButtons.forEach(function (closeButton) {
          closeButton.addEventListener(
            "click",
            function () {
              closeDrawer(true);
            }
          );
        });

        /*
         * Escape closes drawer
         */
        document.addEventListener(
          "keydown",
          function (event) {

            if (
              event.key === "Escape" &&
              stickyDrawer.classList.contains("is-open")
            ) {
              closeDrawer(true);
            }
          }
        );

        /*
         * Our custom close event
         */
        document.addEventListener(
          "zs:close-sticky-drawer",
          function () {

            if (
              stickyDrawer.classList.contains("is-open")
            ) {
              closeDrawer(false);
            }
          }
        );

        /*
         * Theme fallback
         */
        // document.addEventListener(
        //   "cart:updated",
        //   function () {

        //     if (
        //       stickyDrawer.classList.contains("is-open")
        //     ) {
        //       closeDrawer(false);
        //     }
        //   }
        // );

        document.addEventListener(
          "cart:updated",
          function () {

            setTimeout(function(){

              if (
                stickyDrawer.classList.contains("is-open")
              ) {
                  closeDrawer(false);
              }

            },300);

          }
          );
      });
  }

  document.addEventListener(
    "DOMContentLoaded",
    function () {
      initialiseStickyProductFormDrawers(document);
    }
  );

  document.addEventListener(
    "shopify:section:load",
    function (event) {
      initialiseStickyProductFormDrawers(event.target);
    }
  );

})();
// ---

document.addEventListener("DOMContentLoaded", function () {
  const floatingATC = document.querySelector(".zs-sticky-child");
  const actualATC = document.querySelector(".fbt_n_child_atc");
  if (!floatingATC || !actualATC) return;
  function toggleStickyATC() {
    const rect = actualATC.getBoundingClientRect();
    // Show only when the actual ATC is below the viewport
    if (rect.top > window.innerHeight) {
      floatingATC.classList.remove("is-hidden");
    } else {
      floatingATC.classList.add("is-hidden");
    }
  }
  window.addEventListener("scroll", toggleStickyATC, { passive: true });
  window.addEventListener("resize", toggleStickyATC);

  toggleStickyATC();
});


// NEW
document.addEventListener("DOMContentLoaded", function () {
  const floatingATC = document.querySelector(".zs-sticky-product-form");
  const actualATC = document.querySelector(".zs-product-form-area .sr4-product-form__submit");
  if (!floatingATC || !actualATC) return;
  function toggleProductFormStickyATC() {
    const rect = actualATC.getBoundingClientRect();
    if (rect.top > window.innerHeight) {
      floatingATC.classList.remove("is-hidden");
    } else {
      floatingATC.classList.add("is-hidden");
    }
  }
  window.addEventListener("scroll",toggleProductFormStickyATC,{ passive: true });
  window.addEventListener("resize",toggleProductFormStickyATC);
  toggleProductFormStickyATC();
});

// document.addEventListener(
//   "click",
//   function (event) {
//     const addToCartButton = event.target.closest(
//       ".zs-sticky-product-form__drawer [data-atc-form]"
//     );
//     if (!addToCartButton) return;
//     const stickyWrapper = document.querySelector(
//       ".zs-sticky-product-form"
//     );
//     const drawer = document.querySelector(
//       ".zs-sticky-product-form__drawer"
//     );
//     const overlay = document.querySelector(
//       ".zs-sticky-product-form__overlay"
//     );
//     const trigger = document.querySelector(
//       "[data-zs-product-form-open]"
//     );
//     // Close wrapper
//     if (stickyWrapper) {
//       stickyWrapper.classList.remove("is-open");
//     }
//     // Force drawer closed
//     if (drawer) {
//       drawer.setAttribute("aria-hidden", "true");
//       drawer.style.transform = "translateY(105%)";
//     }
//     // Force overlay closed
//     if (overlay) {
//       overlay.style.opacity = "0";
//       overlay.style.visibility = "hidden";
//       overlay.style.pointerEvents = "none";
//     }
//     // Reset sticky trigger
//     if (trigger) {
//       trigger.setAttribute("aria-expanded", "false");
//     }
//     // Restore body scrolling
//     document.body.classList.remove(
//       "zs-sticky-product-form-open"
//     );
//   },
//   true
// );
document.addEventListener(
  "click",
  function (event) {

    const addToCartButton = event.target.closest(
      ".zs-sticky-product-form__drawer [data-atc-form]"
    );

    if (!addToCartButton) return;

    const stickyDrawer = document.querySelector(
      "[data-zs-sticky-product-form]"
    );

    if (!stickyDrawer) return;

    // Trigger existing close function
    const closeButton = stickyDrawer.querySelector(
      "[data-zs-product-form-close]"
    );

    if (closeButton) {
      closeButton.click();
    }

  },
  true
);